import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchFences(ctx, queryParams = {}) {
      return new Promise((resolve, reject) => {
        const {
          search,
          q,
          customerId,
          includeSubcustomers = true,
          page = 1,
          perPage = 20,
        } = queryParams

        const params = {
          page,
          perPage,
          includeSubcustomers,
        }

        const searchTerm = search !== undefined ? search : q
        if (searchTerm && searchTerm.trim() !== '') {
          params.search = searchTerm.trim()
        }

        if (customerId && customerId !== '') {
          params.customerId = customerId
        }

        axios
          .get('/api/v1/VirtualFence/search', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchFence(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/VirtualFence', { params: { id } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addFence(ctx, { fenceData }) {
      return new Promise((resolve, reject) => {
        // Formata o payload garantindo tipos adequados
        const payload = {
          name: fenceData.name,
          lat: fenceData.lat || 0,
          lng: fenceData.lng || 0,
          radius: fenceData.radius ? Number(fenceData.radius) : 0,
          alertIn: Boolean(fenceData.alertIn),
          alertOut: Boolean(fenceData.alertOut),
          alertStayIn: fenceData.alertStayIn !== undefined ? fenceData.alertStayIn : false,
          alertStayOut: fenceData.alertStayOut !== undefined ? fenceData.alertStayOut : false,
          maxSpeed: fenceData.maxSpeed !== null && fenceData.maxSpeed !== '' ? Number(fenceData.maxSpeed) : null,
          virtualFenceGeometryId: fenceData.virtualFenceGeometryId || 1,
          virtualFenceTypeId: fenceData.virtualFenceTypeId || null,
          points: Array.isArray(fenceData.points) ? fenceData.points : [],
        }

        if (fenceData.customerId && fenceData.customerId !== '') {
          payload.customerId = fenceData.customerId
        }

        axios
          .post('/api/v1/VirtualFence', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    updateFence(ctx, { fenceData }) {
      return new Promise((resolve, reject) => {
        // Na atualização o cliente não é enviado (endpoint mantém o cliente original)
        const payload = {
          id: fenceData.id,
          name: fenceData.name,
          lat: fenceData.lat || 0,
          lng: fenceData.lng || 0,
          radius: fenceData.radius ? Number(fenceData.radius) : 0,
          alertIn: Boolean(fenceData.alertIn),
          alertOut: Boolean(fenceData.alertOut),
          alertStayIn: fenceData.alertStayIn !== undefined ? fenceData.alertStayIn : false,
          alertStayOut: fenceData.alertStayOut !== undefined ? fenceData.alertStayOut : false,
          maxSpeed: fenceData.maxSpeed !== null && fenceData.maxSpeed !== '' ? Number(fenceData.maxSpeed) : null,
          virtualFenceGeometryId: fenceData.virtualFenceGeometryId || 1,
          virtualFenceTypeId: fenceData.virtualFenceTypeId || null,
          points: Array.isArray(fenceData.points) ? fenceData.points : [],
        }

        axios
          .put('/api/v1/VirtualFence', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteFence(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete('/api/v1/VirtualFence', { params: { id } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchSearchtype(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/VirtualFence/searchtype')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchCustomers(ctx, queryParams = {}) {
      return new Promise((resolve, reject) => {
        const { q = '', page = 1, perPage = 10 } = queryParams
        axios
          .get('/api/v1/Customer/search', {
            params: {
              Search: q,
              Page: page,
              PerPage: perPage,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchCustomer(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/Customer', { params: { id } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchAddres(ctx, { address }) {
      return new Promise((resolve, reject) => {
        axios
          .get('https://nominatim.openstreetmap.org/search', {
            params: {
              q: address,
              format: 'json',
              limit: 1,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
